import { render, staticRenderFns } from "./TableSwapTournaments.vue?vue&type=template&id=11c36386&scoped=true"
import script from "./TableSwapTournaments.js?vue&type=script&lang=js&external"
export * from "./TableSwapTournaments.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c36386",
  null
  
)

export default component.exports